import React, { useState } from "react";

const animations = [
  { name: "float", className: "animate-float" },
  { name: "pulse", className: "animate-pulse" },
  { name: "grow", className: "animate-grow" },
  { name: "fade-in-up", className: "animate-fade-in-up" },
];

export default function AnimationPlayground() {
  const [darkMode, setDarkMode] = useState(false);
  const [speed, setSpeed] = useState(1);

  const bg = darkMode ? "bg-gray-900" : "bg-gray-100";
  const text = darkMode ? "text-white" : "text-gray-800";
  const boxBg = darkMode ? "bg-white/10" : "bg-black";

  return (
    <section className={`${bg} min-h-screen py-16 px-8 transition-colors`}>
      <div className="max-w-6xl mx-auto space-y-10">
        <div className="flex items-center justify-between">
          <h2 className={`text-3xl font-bold ${text}`}>🎞️ Animation Playground</h2>
          <label className="flex items-center space-x-2 cursor-pointer text-sm">
            <span className={`${text}`}>Dark Mode</span>
            <input
              type="checkbox"
              checked={darkMode}
              onChange={() => setDarkMode(!darkMode)}
              className="w-5 h-5"
            />
          </label>
        </div>

        <div className="flex items-center gap-4">
          <label className={`${text} font-mono`}>Speed: {speed.toFixed(1)}x</label>
          <input
            type="range"
            min="0.5"
            max="2"
            step="0.1"
            value={speed}
            onChange={(e) => setSpeed(parseFloat(e.target.value))}
            className="w-full"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
          {animations.map((anim) => (
            <div key={anim.name} className="text-center">
              <div
                className={`w-32 h-32 rounded-xl ${boxBg} text-white flex items-center justify-center mx-auto text-sm font-mono ${anim.className}`}
                style={{ animationDuration: `${3 / speed}s` }}
              >
                {anim.name}
              </div>
              <div className="mt-2">
                <code
                  className="text-xs bg-white/20 px-2 py-1 rounded font-mono inline-block cursor-pointer"
                  onClick={() => navigator.clipboard.writeText(anim.className)}
                  title="Click to copy"
                >
                  {anim.className}
                </code>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
